import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Card from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes , Route } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
<React.StrictMode>
    <BrowserRouter>
    <Routes>
        <Route path="/" element={<Card/>}/>
    
    </Routes>
    </BrowserRouter>

</React.StrictMode>
)

reportWebVitals();


